export class StockResponseDto {
    saleOrderId: number;
    stockId: number;
    physicalQuantity: number;
    saleOrderItemId?: number;
    
    constructor(saleOrderId:number, stockId: number, physicalQuantity: number,saleOrderItemId?:number) {
        this.saleOrderId = saleOrderId;
        this.stockId = stockId;
        this.physicalQuantity = physicalQuantity;
        this.saleOrderItemId = saleOrderItemId;
    }
}
